/*eslint-disable */
const $ = window.jQuery = require('jquery');

import axios from 'axios';
import briefCaseStorgeAction from "./briefcase-storage-info-action/index.vue";
import briefCaseStorgeInfo from "./briefcase-storage-info/index.vue";
import briefcaseActivityLog from "./briefcase-activity-log/index.vue";
import briefcaseStorageBreakdown from "./briefcaseStorageBreakdown/index.vue";
import { bus } from '@/main';
import errorStorageFull from "./error-storage-full/index.vue";
import percentageLoader from "@/components/common/percentage-loader-f-file";
import root from '@/_helpers/roots';
import sharedBriefcase from "./shared-briefcase/index.vue";

let uploadFolderInBriefcaseApiUrl = root.uploadFolderInBriefcaseApiUrl.link;
let uploadFilesInBriefcaseApiUrl = root.uploadFilesInBriefcaseApiUrl.link;
uploadFolderInBriefcaseApiUrl

export default {
  name: 'briefcase',
  components: {
    'notes-briefcase':sharedBriefcase,
    briefCaseStorgeInfo,
    briefcaseStorageBreakdown,
    errorStorageFull,
    briefcaseActivityLog,
    briefCaseStorgeAction,
    percentageLoader
  },
  props: [],
  data () {
    return {
      submitted:false,
      folderName:'',
      fileName:'',
      newFolderState:false,
      uploadedFilesState:[],
      filesUploadState:false,
      foldersUploadState:false,
      getAllBriefcaseList:null,
      getAllBriefcaseListResults:[],
      firstStepOfBriefcaseState:true,
      firstStepOfToolbarState:true,
      selectedFolderForFirstStep:false,
      folderToolbarData:{},
      removeBriefcasePopup:false,
      removeBriefcaseItemData:{},
      secondStepOfBriefcaseState:false,
      secondStepOfToolbarState:false,
      subfolderListState:false,
      selectedSubFolderForToolbar:false,
      selectedSubfolderToolbarData:{},
      updateBriefcasePopup:false,
      updateBriefcaseItemName:'',
      updateBriefcaseItemId:'',
      gridToList:false,
      getAllSharedBriefcaseList:{},
      getAllSharedBriefcaseListResults:[],
      mainBriefcaseListState:true,
      sharedBriefcaseListState:false,
      sharedBriefcasePopupState:false,
      sharedBriefcaseInfo:{},
      getAllSharedBriefcaseByUserSpcficList:[],
      getAllSharedBriefcaseByUserSpcficState:true,
      selectedSharedFolderForFirstStep:false,
      selectedSharedFolderForSecondStep:false,
      selectedSharedFolderForThirdStep:false,
      selectedSharedFolderForFourStep:false,
      secondStepOfSharedBriefcaseState:false,
      sharedBriefcaseLastStepToolbarData:{},
      sharedBriefcaseThirdStepToolbarData:{},
      sharedBriefcaseFourStepToolbarData:{},
      removeSharedBriefcaseItemData:{},
      removeSharedBriefcasePopupState:false,
      removeSharedBriefcaseUData:'',
      updateSharedBriefcasePopup:false,
      updateSharedBriefcaseItemName:'',
      updateSharedBriefcaseItemId:'',
      updatedSharedBriefcaseUData:'',
      selectedSharedBriefcaseDeleteID:'',
      normalBriefcaseViewState:true,
      errorStorageFullState:false,
      briefcaseStorageBreakdownState:false,
      briefcaseActivityLogState:false,
      uploadedFolderName:'',
      uploadedFolderitems:[],
      uploadProgress:0
    }
  },
  computed: {},
  mounted () {
    this.getBriefcaseListMethod()
    bus.$on('sharedBriefcasePopupStateBus', (data) => {
      this.sharedBriefcasePopupState = data
    })
    bus.$on('normalBriefcaseViewStateBus', (data) => {
      this.normalBriefcaseViewState = data
    })
    bus.$on('briefcaseStorageBreakdownStateBus', (data) => {
      this.briefcaseStorageBreakdownState = data
    })
    bus.$on('briefcaseActivityLogStateBus', (data) => {
      this.briefcaseActivityLogState = data
    })
    bus.$on('errorStorageFullStateBus', (data) => {
      this.errorStorageFullState = data
    })
  },
  methods: {
    normalViewExit(){
      this.normalBriefcaseViewState = true
      this.briefcaseStorageBreakdownState = false
      this.briefcaseActivityLogState = false
    },
    showShareBriefcasePopupMethod(data){
      this.sharedBriefcasePopupState = true
      this.sharedBriefcaseInfo = data
      $('body').addClass('body_right_scroll_remove')
    },
    showSharedBriefcaseMethod(){
      if(this.mainBriefcaseListState == true){
        this.mainBriefcaseListState =  false
        this.getSharedBriefcaseByUserSpcficListMethod()
      }else{
        this.mainBriefcaseListState = true
      }
    },
    gridChangeToListForFirstStepMethod(){
      this.filesUploadState = false
      this.newFolderState = false
      if(this.firstStepOfBriefcaseState == true){
        if(this.gridToList == true){
          this.gridToList = false
        }else{
          this.gridToList = true
        }
      }
      this.firstStepOfBriefcaseState = true
    },
    limitTo: function(value) {
      if (!value) return '';
      if(value.length > 13){
        return value.substring(0, 13) + '...';
      }else{
        return value;
      }
    },
    limitToFileName: function(value) {
      if (!value) return '';
      if(value.length > 10){
        return value.substring(0, 10) + '...';
      }else{
        return value;
      }
    },
    limitToULN: function(value) {
      if (!value) return '';
      if(value.length > 7){
        return value.substring(0, 7) + '...';
      }else{
        return value;
      }
    },
    getBriefcaseListMethod(){
      this.$store.dispatch('getbriefcaselistAction').then((res)=>{
        this.getAllBriefcaseList = res.data.data
        this.getAllBriefcaseListResults = res.data.data.results
        this.getSharedBriefcaseByUserSpcficListMethod()
      }).catch((err)=>{})
    },
    selectionOfActionMethod(arg){
      if(arg == 'uploadFolders'){
        this.filesUploadState = false
        this.newFolderState = false
        this.foldersUploadState = true
      }else if(arg == 'newFolder'){
        this.foldersUploadState = false
        this.filesUploadState = false
        this.newFolderState = true
      }else{
        this.foldersUploadState = false
        this.newFolderState = false
        this.filesUploadState = true
      }
    },
    selectedOptionForNewBriefcaseMethod(arg){
      this.firstStepOfBriefcaseState = false
      this.selectionOfActionMethod(arg);
    },
    selectedOptionForNewSubFolderMethod(arg){
      this.subfolderListState = false
      this.selectionOfActionMethod(arg);
    },
    handleAttachmentUpload(event) {
      if(event.target.files && event.target.files.length > 0) {
        this.files = this.$refs.file.files[0];
        this.uploadedFilesState = event.target.files
        this.fileName = this.files.name
      }else {
        this.fileName = '';
      }
    },
    createNewBriefcaseDataMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          if(this.filesUploadState == true){
            var formData = new FormData();
            for(let i = 0; i < this.uploadedFilesState.length; i++) {
              formData.append('files', this.uploadedFilesState[i]);
            }
            axios.post(uploadFilesInBriefcaseApiUrl, formData, {
              onUploadProgress: progressEvent => {
                this.uploadProgress = Math.round(
                  (progressEvent.loaded / progressEvent.total) * 100
                );
              },
            }).then((res) => {  
                this.submitted =  false
                this.uploadProgress = 0
                this.filesUploadState = false
                this.newFolderState = false
                this.firstStepOfBriefcaseState = true
                this.file = null
                this.fileName = ''
                this.$validator.reset();
                this.getBriefcaseListMethod()
                this.$store.dispatch('getbriefcaseStorageInfoAction')
              }).catch((err) => {
                this.submitted =  false
                if(err.status == '406'){
                  this.errorStorageFullState = true
                  $('body').addClass('body_right_scroll_remove')
                }
              })
              return;
          }else{
            let data = {
              name:this.folderName,
              is_folder:true
            }
            this.$store.dispatch('createBriefcaseDetailsAction', data)
              .then((res) => {  
                this.submitted =  false
                this.filesUploadState = false
                this.newFolderState = false
                this.firstStepOfBriefcaseState = true
                this.folderName = ''
                this.$validator.reset();
                this.getBriefcaseListMethod()
                this.$store.dispatch('getbriefcaseStorageInfoAction')
              }).catch((err) => {
                this.submitted =  false
              })
              return;
          }
        }
      })
    },
    handleAttachmentFolderUpload(event) {
      if(event.target.files && event.target.files.length == 0) return;
      this.uploadedFolderName = event.target.files[0].webkitRelativePath.split('/')[0];
      this.uploadedFolderitems = event.target.files
    },
    folderUploadInBriefcaseMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          var formData = new FormData();
          formData.append('folder_name', this.uploadedFolderName);
          for(let i = 0; i < this.uploadedFolderitems.length; i++) {
            formData.append('files', this.uploadedFolderitems[i]);
          }
          axios.post(uploadFolderInBriefcaseApiUrl, formData, {
            onUploadProgress: progressEvent => {
              this.uploadProgress = Math.round(
                (progressEvent.loaded / progressEvent.total) * 100
              );
            },
          }).then((res) => {
            this.submitted =  false
            this.uploadProgress = 0
            this.foldersUploadState = false
            this.filesUploadState = false
            this.newFolderState = false
            this.firstStepOfBriefcaseState = true
            this.uploadedFolderName = ''
            this.uploadedFolderitems = []
            this.$validator.reset();
            this.getBriefcaseListMethod()
            this.$store.dispatch('getbriefcaseStorageInfoAction')
          }).catch((err) => {
            this.submitted =  false
          })
          return;
        }
      })
    },
    /*
    * This Will Check File Extension In Chat
    */
    checkFileExtension(file) {
      let extension = file.substr((file.lastIndexOf('.') + 1));
      switch (extension.split('?')[0]) {
        case 'jpg':
          return require('@/assets/images/filetype/jpg.png')
          break;
        case 'jpeg':
          return require('@/assets/images/filetype/jpg.png')
          break;
        case 'png':
          return require('@/assets/images/filetype/png.png')
          break;
        case 'gif':
          return require('@/assets/images/filetype/jpg.png')
          break;
        case 'zip':
          return require('@/assets/images/filetype/zip.png')
          break;
        case 'rar':
          return require('@/assets/images/filetype/zip-1.png');
          break;
          break;
        case 'eps':
          return require('@/assets/images/filetype/ai.png')
          break;
        case 'pdf':
          return require('@/assets/images/filetype/pdf.png')
          break;
        case 'css':
          return require('@/assets/images/filetype/css.png')
          break;
        case 'csv':
          return require('@/assets/images/filetype/csv.png')
          break;
        case 'doc':
          return require('@/assets/images/filetype/doc.png')
          break;
        case 'docx':
          return require('@/assets/images/filetype/doc.png')
          break;
        case 'json':
          return require('@/assets/images/filetype/json-file.png')
          break;
        case 'ppt':
          return require('@/assets/images/filetype/ppt.png')
          break;
        case 'pptx':
          return require('@/assets/images/filetype/ppt.png')
          break;
        case 'txt':
          return require('@/assets/images/filetype/txt.png')
          break;
        case 'xls':
          return require('@/assets/images/filetype/xls.png')
          break;
        case 'xlsx':
          return require('@/assets/images/filetype/xls.png')
          break;
        case 'xml':
          return require('@/assets/images/filetype/xml.png')
          break;
        case 'xlsm':
          return require('@/assets/images/filetype/xls.png')
          break;
        case 'py':
          return require('@/assets/images/filetype/python.png')
        case 'cpp':
          return require('@/assets/images/filetype/cpp-file-format-symbol.png')
          break;
        case 'vbb':
          return require('@/assets/images/filetype/coding.png')
          break;
        default:
          return require('@/assets/images/filetype/d_file.png')
      }
    },
    enbaledFolderToolbarMethod(itemData){
      this.folderToolbarData = itemData
      this.firstStepOfToolbarState = false
      this.selectedFolderForFirstStep = true
    },
    enbaledSubFolderToolbarMethod(itemData){
      this.selectedSubfolderToolbarData = itemData
      this.secondStepOfToolbarState = false
      this.selectedSubFolderForToolbar = true
    },
    removeBriefcaseDataMethod(rItemData){
      this.removeBriefcasePopup = true
      this.removeBriefcaseItemData = rItemData
    },
    removeBriefcaseDataConfirmationMethod(){
      this.$store.dispatch('removeBriefcaseDetailsByIdAction', {id:this.removeBriefcaseItemData.id}).then((res)=>{
        this.closeRemoveItemModalFun()
        this.getBriefcaseListMethod()
        if(this.secondStepOfBriefcaseState === true){
          this.$store.dispatch('getBriefcaseDetailsByIdAction', {id:this.folderToolbarData.id}).then((res)=>{
            this.folderToolbarData = res.data.data
            this.subfolderListState = true
          })
        }
      }).catch((err)=>{})
    },
    closeRemoveItemModalFun(){
      if(this.secondStepOfBriefcaseState === true){
        this.removeBriefcaseItemData = {}
        this.removeBriefcasePopup = false
        this.selectedSubfolderToolbarData = {}
        this.firstStepOfToolbarState = false
        this.selectedFolderForFirstStep = false
        this.secondStepOfToolbarState = true
        this.firstStepOfBriefcaseState = false
        this.secondStepOfBriefcaseState = true
      }else{
        this.removeBriefcaseItemData = {}
        this.removeBriefcasePopup = false
        this.folderToolbarData = {}
        this.secondStepOfToolbarState = false
        this.selectedFolderForFirstStep = false
        this.firstStepOfToolbarState = true
        this.secondStepOfBriefcaseState = false
        this.firstStepOfBriefcaseState = true
      }
    },
    enterSubFoldersMethod(itemData){
      if(!itemData.is_folder) return;
      this.folderToolbarData = itemData
      this.firstStepOfBriefcaseState = false
      this.secondStepOfBriefcaseState = true
      this.subfolderListState = true
      this.firstStepOfToolbarState = false
      this.selectedFolderForFirstStep = false
      this.secondStepOfToolbarState = true
    },
    downloadFileFromURlMethod(url, name) {
      var link = document.createElement('a');
      link.href = url
      link.download =  name;
      link.target =  '_blank';
      document.body.appendChild(link);
      link.click();
    },
    createNewSubFolderBriefcaseDataMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          if(this.filesUploadState == true){
            var formData = new FormData();
            formData.append('parent_id ', this.folderToolbarData.id); 
            for(let i = 0; i < this.uploadedFilesState.length; i++) {
              formData.append('files', this.uploadedFilesState[i]);
            }
            axios.post(uploadFilesInBriefcaseApiUrl, formData, {
              onUploadProgress: progressEvent => {
                this.uploadProgress = Math.round(
                  (progressEvent.loaded / progressEvent.total) * 100
                );
              },
            })
              .then((res) => {  
                this.submitted =  false
                this.uploadProgress = 0
                this.newFolderState = false
                this.filesUploadState = false
                this.file = null
                this.fileName = ''
                this.$validator.reset();
                this.$store.dispatch('getBriefcaseDetailsByIdAction', {id:this.folderToolbarData.id}).then((res)=>{
                  this.folderToolbarData = res.data.data
                  this.subfolderListState = true
                })
                this.getBriefcaseListMethod()
              }).catch((err) => {
                this.submitted =  false
              })
              return;
          }
        }
      })
    },
    openUpdateBriefcaseDetailPopup(updateData){
      this.updateBriefcaseItemName = updateData.name
      this.updateBriefcaseItemId = updateData.id
      this.updateBriefcasePopup = true

    },
    updateBriefcaseDataConfirmationMethod(){
      let data = {
        name :this.updateBriefcaseItemName
      }
      this.$store.dispatch('updateBriefcaseDetailsAction',{data:{id:this.updateBriefcaseItemId,data: data}}).then((res)=>{
        this.getBriefcaseListMethod()
        this.closeupdateItemModalFun()
        this.$store.dispatch('getBriefcaseDetailsByIdAction', {id:this.folderToolbarData.id}).then((res)=>{
          this.folderToolbarData = res.data.data
          if(this.secondStepOfBriefcaseState === true){
          this.selectedSubFolderForToolbar =  false
          this.secondStepOfToolbarState = true
          this.selectedSubfolderToolbarData = ''
          this.subfolderListState = true
        }
        })
      }).catch((err)=>{})
    },
    closeupdateItemModalFun(){
      this.updateBriefcaseItemName = ''
      this.updateBriefcaseItemId = ''
      this.updateBriefcasePopup = false
    },
    backToFirstStepMethod(){
      this.folderToolbarData = {}
      this.secondStepOfToolbarState = false
      this.selectedSubFolderForToolbar = false
      this.selectedFolderForFirstStep = false
      this.firstStepOfToolbarState = true
    },
    backToFirstStepFromSecondStepMethod(){
      this.folderToolbarData = {}
      this.secondStepOfBriefcaseState = false
      this.filesUploadState = false
      this.newFolderState = false
      this.firstStepOfBriefcaseState = true
      this.secondStepOfToolbarState = false
      this.selectedSubFolderForToolbar = false
      this.selectedFolderForFirstStep = false
      this.firstStepOfToolbarState = true
    },
    backToSecondStepMethod(){
      this.selectedSubfolderToolbarData = {}
      this.firstStepOfToolbarState = false
      this.selectedFolderForFirstStep = false
      this.selectedSubFolderForToolbar = false
      this.secondStepOfToolbarState = true
    },
    cancelSecondSectionOfCreateEvent(){
      this.file = null
      this.$validator.reset()
      this.filesUploadState = false
      this.newFolderState = false
      this.foldersUploadState = false
      this.subfolderListState = true
    },
    cancelFirstSectionOfCreateEvent(){
      this.file = null
      this.folderName = ''
      this.uploadedFolderName = ''
      this.fileName = ''
      this.$validator.reset()
      this.filesUploadState = false
      this.newFolderState = false
      this.foldersUploadState = false
      this.firstStepOfBriefcaseState = true
    },
    // Shared BriefCase Event Code Here
    getSharedBriefcaseByUserSpcficListMethod(){
      this.$store.dispatch('getShareBriefcaseListUserSpecificAction').then((res)=>{
        this.getAllSharedBriefcaseByUserSpcficList = res.data.data
      }).catch((err)=>{})
    },
    enterSharedFolderByUserSpcficMethod(userSharedData){
      this.$store.dispatch('getSharedBriefcaselistAction',{id:userSharedData.id}).then((res)=>{
        this.folderToolbarData = userSharedData
        this.getAllSharedBriefcaseList = res.data.data
        if(this.getAllSharedBriefcaseList != undefined){
          this.getAllSharedBriefcaseListResults = this.getAllSharedBriefcaseList.results
        }
        this.getAllSharedBriefcaseByUserSpcficState = false
        this.firstStepOfToolbarState = false
        this.selectedSharedFolderForFirstStep = true
      }).catch((err)=>{})
    },
    enterSubSharedFolderMethod(itemData){
      if(!itemData.is_folder) return;
      this.$store.dispatch('getSharedBriefcaseDetailsByIDAction',{id:itemData.id}).then((res)=>{
        this.sharedBriefcaseLastStepToolbarData = res.data.data
        this.sharedBriefcaseThirdStepToolbarData = itemData
        if(this.sharedBriefcaseLastStepToolbarData.sub_folders.length > 0){
          this.firstStepOfBriefcaseState = false
          this.secondStepOfSharedBriefcaseState = true
          this.selectedSharedFolderForSecondStep = false
          this.selectedSharedFolderForThirdStep = true
        }
      }).catch((err)=>{
      })
    },
    backToSecStepFromThirdOfSharedListMethod(){
      this.sharedBriefcaseLastStepToolbarData = {}
      this.selectedSharedFolderForThirdStep = false
      this.selectedSharedFolderForSecondStep = true
      this.secondStepOfSharedBriefcaseState = false
      this.firstStepOfBriefcaseState = true
    },
    backToFirstStepOfSharedListMethod(){
      this.folderToolbarData = false
      this.selectedSharedFolderForFirstStep = false
      this.getAllSharedBriefcaseByUserSpcficState = true
      this.firstStepOfToolbarState = true
    },
    enbaledSharedSubFolderToolbarMethod(itemData){
      this.selectedSharedBriefcaseDeleteID = itemData
      this.selectedSubfolderToolbarData = itemData.briefcase_folder
      this.selectedSharedFolderForFirstStep = false
      this.selectedSharedFolderForSecondStep = true
    },
    backToFirstStepFromSecOfSharedListMethod(){
      this.selectedSubfolderToolbarData = {}
      this.selectedSharedFolderForSecondStep = false
      this.selectedSharedFolderForFirstStep = true
    },
    enbaledSubFolderToolbarOfLastSharedBriefcaseMethod(data){
      this.sharedBriefcaseFourStepToolbarData = data
      this.selectedSharedFolderForThirdStep = false
      this.selectedSharedFolderForFourStep = true
    },
    backToThirdStepFromFourOfSharedListMethod(){
      this.sharedBriefcaseFourStepToolbarData = {}
      this.selectedSharedFolderForFourStep = false
      this.selectedSharedFolderForThirdStep = true
    },
    removeSharedBriefcaseDataMethod(optDataKey,rItemData){
      this.removeSharedBriefcasePopupState = true
      this.removeSharedBriefcaseItemData = rItemData,
      this.removeSharedBriefcaseUData = optDataKey
    },
    removeSharedBriefcaseDataConfirmationMethod(){
      this.$store.dispatch('removeShareBriefcaseDetailsByIDAction', {id:this.selectedSharedBriefcaseDeleteID.id}).then((res)=>{
        this.$store.dispatch('getSharedBriefcaselistAction',{id:this.removeSharedBriefcaseItemData.user}).then((res)=>{
          this.getAllSharedBriefcaseList = res.data.data
          if(this.getAllSharedBriefcaseList != undefined){
            this.getAllSharedBriefcaseListResults = this.getAllSharedBriefcaseList.results
            if(this.getAllSharedBriefcaseListResults.length > 0){
              this.getAllSharedBriefcaseByUserSpcficState = false
              this.firstStepOfToolbarState = false
              this.selectedSharedFolderForSecondStep = false
              this.selectedSharedFolderForFirstStep = true
            }else{
              this.selectedSharedFolderForFirstStep = false
              this.selectedSharedFolderForSecondStep = false
              this.selectedSharedFolderForThirdStep = false
              this.selectedSharedFolderForFourStep = false
              this.selectedSharedFolderForThirdStep = false
              this.selectedSharedFolderForSecondStep = false
              this.secondStepOfSharedBriefcaseState = false
              this.firstStepOfBriefcaseState = true
              this.getAllSharedBriefcaseByUserSpcficState = true
              this.firstStepOfToolbarState = true
              this.getSharedBriefcaseByUserSpcficListMethod()
            }
          }
        }).catch((err)=>{})
        this.closeRemoveSharedItemModalFun()
      }).catch((err)=>{
        this.selectedSharedBriefcaseDeleteID = ''
      })
    },
    closeRemoveSharedItemModalFun(){
      if(this.secondStepOfSharedBriefcaseState === true){
        this.removeSharedBriefcaseItemData = {}
        this.removeSharedBriefcasePopupState = false
      }else{
        this.removeSharedBriefcaseItemData = {}
        this.removeSharedBriefcasePopupState = false
      }
    },
    openUpdateSharedBriefcaseDetailPopup(optDataKey, updateData){
      this.updateSharedBriefcaseItemName = updateData.name
      this.updateSharedBriefcaseItemId = updateData.id
      this.updateSharedBriefcasePopup = true
      this.updatedSharedBriefcaseUData = optDataKey
    },
    updateSharedBriefcaseDataConfirmationMethod() {
      let data = {
        name: this.updateSharedBriefcaseItemName
      }
      this.$store.dispatch('updateBriefcaseDetailsAction', { data: { id: this.updateSharedBriefcaseItemId, data: data } }).then((res) => {
        if (this.updatedSharedBriefcaseUData == 'selectedSubfolderToolbarData') {
          this.selectedSubfolderToolbarData = res.data.data
          this.$store.dispatch('getSharedBriefcaselistAction',{id:res.data.data.user}).then((res)=>{
            this.getAllSharedBriefcaseList = res.data.data
            if(this.getAllSharedBriefcaseList != undefined){
              this.getAllSharedBriefcaseListResults = this.getAllSharedBriefcaseList.results
            }
          })
        }else if (this.updatedSharedBriefcaseUData == 'sharedBriefcaseFourStepToolbarData') {
          this.sharedBriefcaseFourStepToolbarData = res.data.data
          this.$store.dispatch('getSharedBriefcaseDetailsByIDAction', { id: res.data.data.parent }).then((res) => {
            this.sharedBriefcaseLastStepToolbarData = res.data.data
          })
        }
        this.closeupdateSharedBriefcaseItemModalFun()
      }).catch((err) => {

      })
    },
    closeupdateSharedBriefcaseItemModalFun(){
      this.updateSharedBriefcaseItemName = ''
      this.updateSharedBriefcaseItemId = ''
      this.updateSharedBriefcasePopup = false
    },
  }
}